import { render, staticRenderFns } from "./PrimaryContact.vue?vue&type=template&id=f268b848&"
import script from "./PrimaryContact.vue?vue&type=script&lang=js&"
export * from "./PrimaryContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports